module.exports = __webpack_public_path__ + "img/velans2.3b7dd86.jpg";